import styled from "styled-components";

export const Content = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f2f2f2;
  gap: 50px;
`;

export const Header = styled.section`
  width: 100%;
  height: 110px;
  background-color: white;
  padding: 0 200px;
  display: flex;
  align-items: center;
  justify-content: start;
`;

export const TableSection = styled.section`
  padding: 0 200px;
  width: 100%;
  overflow-y: auto;

  @media (max-width: 1540px) {
    padding: 0 100px;
  }

  @media (max-width: 1340px) {
    padding: 0 50px;
  }

  @media (max-width: 850px) {
    padding: 0 10px;
  }
`;

export const SwitchContainer = styled.section`
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 100px;

  span {
    font-weight: 800;
  }
`;
